import { takeEvery, call } from 'redux-saga/effects';
import history from '~/store/history';
import * as actions from './actions';

export function* redirectUser({
  payload: { path, search, pushToHistory = true },
}: ReturnType<typeof actions.redirectUser>) {
  if (pushToHistory) {
    yield call(history.push, {
      pathname: path,
      search,
    });
  } else {
    yield call(history.replace, {
      pathname: path,
      search,
    });
  }
}

export function* redirectUserSaga() {
  yield takeEvery(actions.redirectUser.type, redirectUser);
}

export default [redirectUserSaga];
